import { topicItems } from '@/mocks/home';

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-2">
            话题热榜
          </h2>
          <p className="text-sm text-foreground-500">全网热议话题实时追踪，热度排行一目了然</p>
        </div>

        <div className="flex flex-wrap justify-center gap-3">
          {topicItems.map((item, i) => (
            <a
              key={i}
              href="#updates"
              onClick={(e) => {
                e.preventDefault();
                document.getElementById('updates')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="inline-flex items-center gap-2 px-4 py-2.5 bg-background-50 rounded-full border border-background-200/70 hover:border-primary-200 hover:bg-primary-50 transition-all duration-200 cursor-pointer"
            >
              <i className={`${item.icon} ${item.color} text-sm`}></i>
              <span className="text-sm font-medium text-foreground-800 whitespace-nowrap">{item.name}</span>
              <span className="text-[11px] text-foreground-400">{item.heat}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}